/// <reference path="../../../../../typings/tsd.d.ts" />
/// <reference path="api.d.ts" />

/* tslint:disable:no-unused-variable member-ordering */

namespace API.Client {
    'use strict';

    export class SellersApi {
        protected basePath = '/proxy/oag/gtw_rh';
        public defaultHeaders : any = {};

        static $inject: string[] = ['$http', '$httpParamSerializer'];

        constructor(protected $http: ng.IHttpService, protected $httpParamSerializer?: (d: any) => any, basePath?: string) {
            if (basePath) {
                this.basePath = basePath;
            }
        }

        private extendObj<T1,T2>(objA: T1, objB: T2) {
            for(let key in objB){
                if(objB.hasOwnProperty(key)){
                    objA[key] = objB[key];
                }
            }
            return <T1&T2>objA;
        }

        /**
         * 
         * 
         * @param branchCodeCVC 
         * @param saleTypeCode 
         * @param agencyCode 
         */
        public sellerGet (branchCodeCVC: number, saleTypeCode: number, saleSystem: string, agencyCode?: number, extraHttpRequestParams?: any ) : ng.IHttpPromise<SellersRS> {
            const localVarPath = this.basePath + '/seller';

            let queryParameters: any = {};
            let headerParams: any = this.extendObj({}, this.defaultHeaders);
            // verify required parameter 'branchCodeCVC' is set
            if (!branchCodeCVC) {
                throw new Error('Missing required parameter branchCodeCVC when calling sellerGet');
            }
            // verify required parameter 'saleTypeCode' is set
            if (!saleTypeCode) {
                throw new Error('Missing required parameter saleTypeCode when calling sellerGet');
            }
            // verify required parameter 'saleSystem' is set
            if (!saleSystem) {
                throw new Error('Missing required parameter saleSystem when calling sellerGet');
            }
            if (branchCodeCVC !== undefined) {
                queryParameters['branchCodeCVC'] = branchCodeCVC;
            }

            if (saleTypeCode !== undefined) {
                queryParameters['saleTypeCode'] = saleTypeCode;
            }

            if (saleSystem !== undefined) {
                queryParameters['saleSystem'] = saleSystem;
            }

            if (agencyCode !== undefined) {
                queryParameters['agencyCode'] = agencyCode;
            }

            let httpRequestParams: any = {
                method: 'GET',
                url: localVarPath,
                json: true,
                params: queryParameters,
                headers: headerParams
            };

            if (extraHttpRequestParams) {
                httpRequestParams = this.extendObj(httpRequestParams, extraHttpRequestParams);
            }

            return this.$http(httpRequestParams);
        }
    }
}
